<div mat-dialog-title class="cust-modal-title">
    <h2 class="m-0">{{ parentData.title }}</h2>
    <button mat-icon-button mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <mat-dialog-content>
    <div>
      <mat-form-field appearance="outline" style="width: 100%">
        <mat-label>Name</mat-label>
        <input [(ngModel)]="newbookingData.customerName" matInput />
        
      </mat-form-field>
    </div>
    <!-- <div>
      <mat-form-field appearance="outline" style="width: 100%">
        <mat-label>Phone</mat-label>
        <input [(ngModel)]="newbookingData.customerPh" matInput  type="tel" smNumericOnly
        maxlength="10"/>
        
      </mat-form-field>
    </div> -->
    <div class="row g-2  justify-content-between phone-field">
      <mat-form-field appearance="outline" class="col-2 country_form">
        <mat-label>Country</mat-label>
        <mat-select [(ngModel)]="selectedCountryCode" required (selectionChange)="onCountrySelected($event)" >
          <mat-select-trigger>
            {{ "(" + selectedCountryCode.dial_code + ")" }}
          </mat-select-trigger>
          <div>
            <input
            style="width: 80%;
            height: 25px;
            padding: 10px;
            border: 1px solid lightgray;
            margin: 10px;
            border-radius: 5px;
        "
            [(ngModel)]="searchString"

              matInput
              placeholder="Enter country name"
              (keyup)="onKey()"
            />
          </div>
            
          <mat-option
            *ngFor="let country of countryList"
            [value]="country"

          >
            {{ country.flag }} {{ country.name }}
            {{ "(" + country.dial_code + ")" }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field class="mobile_form col-10" appearance="outline" >
        <mat-label>Phone</mat-label>
        <input [(ngModel)]="newbookingData.customerPh" matInput  type="tel" smNumericOnly
        maxlength="10">
        <mat-hint style="color: red;
    font-size: 13px;" align="end" *ngIf="newbookingData.customerPh && newbookingData.customerPh != '' &&  newbookingData.customerPh.length < 10 ">Enter a valid phone number.</mat-hint>
      </mat-form-field>
    </div>
    <div>
        <mat-form-field class="w-100" appearance="outline" class="col-12" (click)="picker0.open()" style="padding: 0px;">
            <mat-label>Select Date</mat-label>
            <input matInput [matDatepicker]="picker0" [(ngModel)]="selectedDate" readonly [min]="tomorrowDate" [max]="maxDate">
    
            <mat-datepicker-toggle matSuffix [for]="picker0"></mat-datepicker-toggle>
            <mat-datepicker #picker0 disabled="false"></mat-datepicker>
          </mat-form-field>
    </div>
    <div class="mb-3_t">

        <mat-form-field class="w-100" appearance="outline" (click)="pickerA.open()">
          <mat-label>Select Time</mat-label>
          <input matInput
                 name="selected_time_A"
                 [ngxMatTimepicker]="pickerA"
                 readonly
                 [(ngModel)]="selectedTime"/>
          <mat-icon matSuffix style="margin-right: 4px;">
            access_time
          </mat-icon>
      </mat-form-field>
      <ngx-mat-timepicker #pickerA></ngx-mat-timepicker>
      </div>
    <div class="chip_cont" style="border-bottom: 1px solid lightgray;">
        <mat-chip-listbox aria-label="Fish selection" class="mb-3">
          <mat-chip
           
      [ngClass]="{ selectedPurple: selectedServiceType == 1 }"
      (click)="changeChip(1)"
            >Shop Service
          </mat-chip>
        </mat-chip-listbox>
      
        <mat-chip-listbox aria-label="Fish selection" class="mb-3">
          <mat-chip
           
            [ngClass]="{ selectedPurple: selectedServiceType == 0 }"
      (click)="changeChip(0)"
            >Home Service
          </mat-chip>
        </mat-chip-listbox>
      </div>
    <div class="chip_cont" style="padding: 20px 0px;">
      <mat-chip-listbox class="example-chip" *ngIf="serviceList.length > 0">
        <div *ngFor="let item of serviceList">
          <mat-chip
            *ngIf="item.toShow"
            
            (click)="selectServices(item)"
            >{{ item.serviceName }}
          </mat-chip>
        </div>
     

      </mat-chip-listbox>
      <p *ngIf="serviceList.length == 0">No service added</p>
      </div>
      <h3 *ngIf="selectedJobs.length > 0">Job selected</h3>
    <div class="chip_cont" *ngIf="selectedJobs.length > 0">
        
      
        <mat-chip-listbox aria-label="Fish selection" class="mb-3">
          <mat-chip
            
            class="selected"
      *ngFor="let item of selectedJobs"
            >{{item.serviceName}}
            <mat-icon matChipRemove (click)="removeSelectedJobs(item)" style="color: red;
            opacity: 1;">cancel</mat-icon>
          </mat-chip>
        </mat-chip-listbox>
      </div>
    <div>
      <mat-form-field appearance="outline" style="width: 100%">
        <mat-label>Cost</mat-label>
        <input [(ngModel)]="newbookingData.price" matInput  [disabled]="true"/>
        
      </mat-form-field>
    </div>
    <div>
      <mat-form-field appearance="outline" style="width: 100%">
        <mat-label>Notes</mat-label>
        <textarea [(ngModel)]="newbookingData.note" matInput></textarea>
        <!-- <mat-icon matSuffix class="material-icons-outlined">message</mat-icon> -->
      </mat-form-field>
    </div>
  </mat-dialog-content>
  
  <mat-dialog-actions align="end">
    <button mat-button mat-dialog-close *ngIf="selectedBookingType == 1">Cancel</button>
    <button
    *ngIf="selectedBookingType == 1"
      mat-flat-button
      color="accent"
      (click)="onPost()"
      [disabled]="
      selectedJobs.length == 0 ||
      formChecker()
      "
    >
      Create new booking
    </button>

<!-- 
    <button mat-button  *ngIf="selectedBookingType == 4" style="border: 1px solid #b48700;" [disabled]="
    selectedJobs.length == 0
    "
    (click)="allDoneAndRelease()"
    >All done and release</button>
    <button mat-button  *ngIf="selectedBookingType == 4" style="border: 1px solid #b48700;" [disabled]="
    selectedJobs.length == 0
    "
    (click)="partiallyDone()"
    >Partially done and release</button>
    <button
    *ngIf="selectedBookingType == 4"
      mat-flat-button
      color="accent"
      (click)="allDone()"
      [disabled]="
      selectedJobs.length == 0
      
      "
    >
      All done and produce bill
    </button> -->
  </mat-dialog-actions>
  